import { DEFAULT_ICON_ID, MAX_ICON_ID, MIN_ICON_ID } from '@app/constants/devicesIconsRestrictions'

export const checkIconNumber = (iconId: number): number => ((iconId >= MIN_ICON_ID && iconId <= MAX_ICON_ID) ? iconId : DEFAULT_ICON_ID)
